import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import { isSameData, cloneDataOrNull } from '../../../dto/data-model-utils.js';
import { CartDiscountDto } from './dtos/cart-discount-dto.js';

export class DiscountChangedPayload extends Payload {
  static readonly TYPE_ID = '0324a87e07484239b322e34d0ac30784';

  private constructor(
    public readonly cartDiscountDto: CartDiscountDto | null,
  ) {
    super();
  }

  get $typeId(): string {
    return DiscountChangedPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.DiscountChanged;
  }

  static create(args: {
    cartDiscountDto: CartDiscountDto | null;
  }): DiscountChangedPayload {
    return new DiscountChangedPayload(args.cartDiscountDto);
  }

  static fromMap(context: SerializationContext, map: SerializedData): DiscountChangedPayload {
    return DiscountChangedPayload.create({
      cartDiscountDto: context.fromDataOrNull<CartDiscountDto>(MapUtils.getRecordOrNull(map, 'cartDiscountDto')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'cartDiscountDto': context.toDataOrNull(this.cartDiscountDto),
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    cartDiscountDto = cloneDataOrNull(this.cartDiscountDto),
  }: {
    cartDiscountDto?: CartDiscountDto | null;
  } = {}): this {
    return DiscountChangedPayload.create({ cartDiscountDto }) as this;
  }

  isSame(other: DiscountChangedPayload): boolean {
    return this === other || (
      isSameData(this.cartDiscountDto, other.cartDiscountDto)
    );
  }
}

export class DiscountChangedPayloadBuilder extends DataModelBuilder<DiscountChangedPayload> {
  build(context: SerializationContext, map: SerializedData): DiscountChangedPayload {
    return DiscountChangedPayload.fromMap(context, map);
  }
}
